// import EventBus from '@/plugins/eventbus'
import { stateGetters, stateSetters } from '@/store/store-utils'
import Trade from '@/store/models/user/Trade'

import mutations from './mutations'
import actions from './actions'
import socketActions from './socket-actions'

const defaultState = {
  session: undefined,
  banned: false,
  rewards: [],
  levelCaseCooldown: 0,
  inventory: [],
}

export default {
  name: 'user',
  namespaced: true,
  state: () => defaultState,
  getters: {
    ...stateGetters(defaultState),
    pendingTrades() {
      return Trade.query().where('isPending', true).get()
    },
    betRequirement(state) {
      const { session: user } = state

      if (!user) return null

      return user.betRequirement - (user.stats?.scrapBetSum ?? 0)
    },
  },
  mutations: {
    ...stateSetters(defaultState),
    ...mutations,
  },
  actions: {
    ...actions,
    ...socketActions,
  },
}

// EventBus.$once('app.created', async vm => {
//
// })
